<template>
  <v-container v-if="tournamentparticipant">
  <div v-if="tournamentparticipant" class="resumen_tournament">
    <v-row>
      <v-col>
    <div class="pt-3"> {{tournament.title}} </div>
      </v-col>
    </v-row>
  <v-row>
    <v-col>
      <div>Fecha: {{tournament.start_date}}</div>
    </v-col>
  </v-row>
    <v-row>
    <v-col>
      <div>ELO : {{tournamentparticipant.elo_participant}}</div>
    </v-col>
      <v-col>
      <div> Ganancias: {{roundNumberToDecimal(tournamentparticipant.diff_elo)}}</div>
    </v-col>
  </v-row>
    <v-row>
    <v-col>
      <div>Jugador : {{tournamentparticipant.person.full_name}}</div>
    </v-col>

  </v-row>
    <v-row>
    <v-col>
      <div>Puntos : {{tournamentparticipant.points}}</div>
    </v-col>

  </v-row>

    <v-row>
    <v-col v-if="tournament.club">
      <div>Club: {{tournament.club.name}}</div>
    </v-col>
  </v-row>
  </div>
  <template v-if="tournament">

  <v-row>

    <v-col offset="1" cols="10">
      <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">
          Ronda
        </th>
        <th class="text-center">
          Blancas
        </th>
        <th class="text-center">
          Negras
        </th>
        <th class="text-center">
          Diff
        </th>
        <th class="text-center">
          Resultado
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in tournamentparticipant.games"
        :key="item.id"
      >
        <td class="text-center">{{ item.round.round_number }}</td>
        <td class="text-center" v-if="item.white_entity.id == tournamentparticipant.person.id"><b>{{ item.white_entity.first_name }} {{ item.white_entity.last_name }}</b></td>
        <td class="text-center" v-else>{{ item.white_entity.first_name }} {{ item.white_entity.last_name }}</td>
        <td class="text-center" v-if="item.black_entity">
          <template v-if="item.black_entity.id == tournamentparticipant.person.id">
            <b>{{ item.black_entity.first_name }} {{ item.black_entity.last_name }}</b>
          </template>
          <template v-else>
            {{ item.black_entity.first_name }} {{ item.black_entity.last_name }}
          </template>
        </td>
        <td class="text-center" v-else>No emparejado</td>
        <td class="text-center" v-if="item.white_entity.id == tournamentparticipant.person.id">{{ roundNumberToDecimal(item.white_diff) }}</td>
        <td class="text-center" v-else>{{ roundNumberToDecimal(item.black_diff) }}</td>
        <td class="text-center">
          <p v-if="item.result=='W'"> 1-0</p>
          <p v-else-if="item.result=='B'"> 0-1</p>
          <p v-else-if="item.result=='D'"> 0.5-0.5</p>
          <p v-else-if="item.result=='H'"> + -</p>
          <p v-else-if="item.result=='L'"> - +</p>
          <p v-else> </p>
        </td>
      </tr>
    </tbody>
  </v-table>

    </v-col>
  </v-row>
</template>
  </v-container>
</template>
<script>

import gql from "graphql-tag";
import {mapState} from "vuex";
export default {
  props:["id"],
  apollo: {
    tournamentparticipant: {query: gql` query($id:String!){
       tournamentparticipant(id:$id){
          person {
            id
            full_name:fullName
            federation_id:federationId
            club_id:clubId
          }
          tournament{
            title
            start_date:startDateFormated
            factor
          }
          categoryTournament{
             name
          }
          games{

            result
            white_diff:whiteDiff
            black_diff:blackDiff
            round{
              round_number:roundNumber
            }
            white_entity:whiteEntity{
              id
              first_name:firstName
              last_name:lastName
            }
            black_entity:blackEntity{
              id
              first_name:firstName
              last_name:lastName
            }
          }
          points
          elo_participant:eloParticipant
          diff_elo:diffElo
      }
    }`,
      variables() {return {"id" :this.id}}
    },
  },
  name:"SeeTournamentResult",
  data() {
    return {
      categories_created:[],
      category_selected:null,
      tournamentparticipant:null,
      tournament:null,
      tournament_type:"Suizo",
      tournament_name:"",
      file: null,
      errors:[],
      download:false,
      options: ["Suizo","Equipos", "Round Robin"],
      round_selected:null,
    }
  },
  computed: {
    ...mapState(['is_authenticated']),
  },
  methods: {
    roundNumberToDecimal(number) {
      if(!number){
        return number
      }
      return parseFloat((1*number)*(1*this.tournament.factor)).toFixed(1); // Redondear a un decimal
    },
    onChange() {
      console.log("this.content",this.content)
    },
    uploadCallback(url) {
      console.log('uploaded url', url)
    },
    onFileChange(event){
      this.file = event.target.files[0];
    },
  },
  watch:{
    '$apollo.loading'(val){
      console.log(val)
      if(!val){
        this.tournament = this.tournamentparticipant.tournament;
        this.category_selected = this.tournamentparticipant.categoryTournament;
      }

  },
}
}
</script>
<style>
.resumen_tournament{
  font-family: Montserrat;
font-size: 30px;
font-weight: 600;
line-height: 37px;
letter-spacing: 0em;
text-align: left;
color: #F4F4F4;
  background-color:#2A4558;
  text-align: center;

}

.red-background {
  background-color: coral;
}
@media (max-width: 600px) {
  .resumen_tournament{
    font-size: 24px;
  }
}
</style>
